// filepath: apps/web/src/editors/form-builder/FormBuilderRoute.tsx
//
// FR-UI-BLD-1 AC-5 — staging-only gate. URL:
//   /admin/forms/new
//   /admin/forms/:formId/edit
//
// The SPA gates the route via the existing StagingOnlyError. The
// server additionally returns HTTP 403 ENV_PRODUCTION (ISS-253).

import React from "react";
import { StagingOnlyError } from "@/features/admin/StagingOnlyError";
import { FormBuilderPage } from "./FormBuilderPage";

interface FormBuilderRouteProps {
  environmentKind: string;
  formId?: string;
}

export function FormBuilderRoute({
  environmentKind,
  formId: _formId,
}: FormBuilderRouteProps): React.ReactElement {
  if (environmentKind !== "staging") {
    return <StagingOnlyError environmentKind={environmentKind} />;
  }
  return <FormBuilderPage environmentKind={environmentKind} />;
}
